import menu from './menu.json';
import initialMenu from './initialMenu.json';
import articleMenu from './articleMenu.json';
import shopSelector from './shopSelector.json';
import enterAddress from './enterAddress.json';
import cart from './cart.json';
import trackingOrder from './trackingOrder.json';
import payment from './payment.json';
import coupon from './coupon.json';
import notFound from './notFound.json';
import preorder from './preorder.json';
import profile from './profile.json';
import home from './home.json';

export const EN = {
  menu,
  initialMenu,
  articleMenu,
  shopSelector,
  enterAddress,
  cart,
  trackingOrder,
  payment,
  coupon,
  notFound,
  preorder,
  profile,
  home,
};
